/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d]
import Modal from '@tcp/core/src/components/common/molecules/Modal';
import { getViewportInfo, isClient } from '@tcp/core/src/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { change, Field, reduxForm } from 'redux-form';
import { BRAND_NAMES } from '@tcp/core/src/constants/pageTitle.constants';
import { getIconPath, getLocator } from '../../../../../../../../../utils';
import BodyCopy from '../../../../../../../../common/atoms/BodyCopy';
import Button from '../../../../../../../../common/atoms/Button';
import Col from '../../../../../../../../common/atoms/Col';
import Image from '../../../../../../../../common/atoms/Image';
import InputCheckbox from '../../../../../../../../common/atoms/InputCheckbox';
import LabeledRadioButton from '../../../../../../../../common/atoms/LabeledRadioButton';
import Row from '../../../../../../../../common/atoms/Row';
import withStyles from '../../../../../../../../common/hoc/withStyles';
import GIFT_SERVICES_CONSTANTS from '../GiftServices.constants';
import styles from '../styles/GiftServices.style';
import GiftServicesDetailsModal from './GiftServicesDetailsModal.view';
import {
  getLabelFromCopyOrFromTranslation,
  getLabelWithDefaultValue,
  renderLabel,
} from '../../../../../../../../../utils/labels/labelUtilty';
import ShippingPageLabels, {
  ADDRESS_LABELS,
  SHIPPING_LABELS,
  lblAddGiftServices,
  lblGsNoteTxt,
  lblGsWarningTxt,
} from '../../../views/ShippingPage.labels';
import CheckoutLabels, {
  lblOrderledgerFree,
} from '../../../../../../../../../utils/labels/cnc/checkout.labels';
import SfsWarningPrompt from '../../../../../../SinglePageCheckout/molecules/common/SfsWarningPrompt.view';
import { hasGiftServiceError } from '../../../../../util/utility';

const MAX_LENGTH = 100;
const GIFT_SERVICES = 'gift-services';

const getInitialValues = (ownProps) => {
  const { savedGiftService = {}, spc = false, initialValues = {} } = ownProps || {};
  return spc ? { ...savedGiftService } : initialValues;
};

const getTextFieldHeadingText = (labels, maxLength, message, textFieldMessage = '') => {
  const shippingPageLabels = getLabelFromCopyOrFromTranslation(SHIPPING_LABELS, ShippingPageLabels);
  return (
    <>
      <Row fullBleed className="messageTextWrapper">
        <Col className="add-message-text" colSize={{ small: 3, medium: 4, large: 3 }}>
          <BodyCopy
            color="gray.900"
            fontSize="fs14"
            fontFamily="secondary"
            textAlign="left"
            fontWeight="bold"
          >
            {renderLabel(
              shippingPageLabels?.lbl_giftServices_addMessage,
              'lbl_giftServices_addMessage'
            )}
          </BodyCopy>
        </Col>
        <Col className="add-message-text" colSize={{ small: 3, medium: 4, large: 3 }}>
          <BodyCopy
            color="gray.900"
            fontSize="fs12"
            fontFamily="secondary"
            textAlign="right"
            fontWeight="regular"
          >
            {renderLabel(
              shippingPageLabels?.lbl_giftServices_charLimit,
              'lbl_giftServices_charLimit'
            ) &&
              `${renderLabel(
                shippingPageLabels?.lbl_giftServices_charLimit,
                'lbl_giftServices_charLimit'
              ).substr(4)} ${textFieldMessage.length}/${MAX_LENGTH}`}
          </BodyCopy>
        </Col>
      </Row>
      <Row className="edit-form-css" fullBleed>
        <Col colSize={{ small: 6, medium: 6, large: 6 }}>
          <Field
            name="message"
            value={message}
            normalize={maxLength(MAX_LENGTH)}
            id="message"
            component="textarea"
            dataLocator="gift-message"
            className="gift-message"
          />
        </Col>
      </Row>
    </>
  );
};

const getGiftServicesContent = ({
  isMobileView,
  isShippingCheckboxSelected,
  isGcEnabledOnBagSection,
}) => {
  return isMobileView || isShippingCheckboxSelected || isGcEnabledOnBagSection;
};

const getMyBagIconDimensions = ({ isMobileView }) => {
  let iconHeight = '32px';
  let iconWidth = '32px';
  if (isMobileView) {
    iconHeight = '33px';
    iconWidth = '24px';
  }
  return { iconHeight, iconWidth };
};

const getIconDimensions = ({ isMobileView }) => {
  let iconHeight = '22px';
  let iconWidth = '21px';
  if (isMobileView) {
    iconHeight = '27px';
    iconWidth = '26px';
  }
  return { iconHeight, iconWidth };
};

const isEnterKey = (e) => {
  return e?.keyCode === 13 || e?.key === 'Enter';
};

export const GiftServicesHeaderContentNew = ({
  isMobileView,
  handleChange,
  isModalOpen,
  savedGiftService,
  currencySymbol,
  isMixedOrder,
  shippingPageLabels,
}) => {
  const mobileViewOpen = isMobileView && isModalOpen;
  const { iconHeight, iconWidth } = getMyBagIconDimensions({ isMobileView });
  const { message, price, name, hasGiftWrapping } = savedGiftService || {};
  return (
    <Row
      fullBleed
      onClick={handleChange}
      onKeyDown={(e) => {
        if (isEnterKey(e)) {
          handleChange();
        }
      }}
    >
      <Col colSize={{ small: 6, medium: 8, large: 12 }}>
        <div className="gift-service-header-content">
          <Row fullBleed className="gift-service-header-image">
            <Image
              className={`header-icon ${!mobileViewOpen ? 'elem-pl-SM' : ''}`}
              width={iconWidth}
              height={iconHeight}
              src={getIconPath('mybag-gift-services')}
              alt="mybag-gift-services"
            />
            <BodyCopy
              component="div"
              className="gift-service-header-text"
              fontFamily="secondary"
              fontWeight="bold"
              fontSize="fs14"
              color="black"
            >
              {hasGiftWrapping
                ? `${name} ${
                    price
                      ? `${currencySymbol}${price}`
                      : getLabelFromCopyOrFromTranslation(
                          `checkout.bagPage.${lblOrderledgerFree}`,
                          CheckoutLabels
                        )
                  }`
                : getLabelWithDefaultValue(shippingPageLabels, lblAddGiftServices)}
              <BodyCopy
                component="span"
                className="gift-service-selected-text"
                fontFamily="secondary"
                fontWeight="bold"
                fontSize="fs14"
              >
                {message}
              </BodyCopy>
            </BodyCopy>
          </Row>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
          >
            <path
              d="M11.0003 21C10.6163 21 10.2323 20.853 9.93984 20.5605C9.35339 19.974 9.35339 19.026 9.93984 18.4396L14.8789 13.5002L9.93984 8.56081C9.35339 7.97433 9.35339 7.02635 9.93984 6.43986C10.5263 5.85338 11.4742 5.85338 12.0607 6.43986L18.0602 12.4397C18.6466 13.0262 18.6466 13.9742 18.0602 14.5607L12.0607 20.5605C11.7682 20.853 11.3842 21 11.0003 21Z"
              fill="#005D95"
            />
          </svg>
        </div>
        {isMixedOrder && (
          <BodyCopy
            component="div"
            className="mixed-cart-warning-wrapper"
            fontFamily="secondary"
            fontWeight="bold"
            color="black"
            fontSize="fs12"
          >
            <span>{getLabelWithDefaultValue(shippingPageLabels, lblGsNoteTxt)}</span>
            <span className="gc-warning-text">
              {getLabelWithDefaultValue(shippingPageLabels, lblGsWarningTxt)}
            </span>
          </BodyCopy>
        )}
      </Col>
    </Row>
  );
};

export const GiftServicesHeaderContent = ({
  isMobileView,
  labels,
  addGiftServicesTitle,
  handleChange,
  isModalOpen,
}) => {
  const mobileViewOpen = isMobileView && isModalOpen;
  const { iconHeight, iconWidth } = getIconDimensions({ isMobileView });
  return (
    <Row fullBleed>
      <Col colSize={{ small: 6, medium: 8, large: 12 }}>
        <div className="checkbox-header elem-mt-LRG">
          <Field
            customHandleChange
            name="hasGiftWrapping"
            component={InputCheckbox}
            dataLocator={getLocator('gift_service')}
            enableSuccessCheck={false}
            onChange={(e) => handleChange(e)}
            className={`giftServicesField ${mobileViewOpen ? 'no-visile' : ''}`}
            labels={labels}
            ariaLabel={addGiftServicesTitle}
            spc
          />
          <Row fullBleed className={`checkbox-header  ${mobileViewOpen ? 'no-visile' : 'title'}`}>
            <Image
              className={`header-icon ${!mobileViewOpen ? 'elem-pl-SM' : ''}`}
              width={iconWidth}
              height={iconHeight}
              src={getIconPath(GIFT_SERVICES)}
              alt="mailing-address"
            />
            <BodyCopy
              component="div"
              className="elem-pl-XS elem-mt-XXXS"
              fontFamily="secondary"
              fontWeight="bold"
              fontSize={isMobileView ? 'fs18' : 'fs14'}
            >
              {addGiftServicesTitle}
            </BodyCopy>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

class GiftServicesSPC extends React.PureComponent {
  shippingPageLabels = getLabelFromCopyOrFromTranslation(SHIPPING_LABELS, ShippingPageLabels);

  addressLabels = getLabelFromCopyOrFromTranslation(ADDRESS_LABELS, ShippingPageLabels);

  constructor(props) {
    super(props);
    const { isGiftServicesChecked, initialValues } = this.props;
    this.state = {
      detailStatus: false,
      isChecked: isGiftServicesChecked,
      message: initialValues.message,
      isModalOpen: false,
      giftType: '',
    };
  }

  handleChange = (e) => {
    const { isChecked } = this.state;
    const { handleAnalytics, deselectCallback } = this.props;

    const hasGiftWrapping = !isChecked;
    this.setState({
      isChecked: hasGiftWrapping,
    });
    if (e.currentTarget) {
      e.currentTarget.blur();
    }
    handleAnalytics();
    if (!hasGiftWrapping) {
      deselectCallback();
    }
  };

  componentDidUpdate() {
    const { isModalOpen } = this.state;
    const { sfsError, isGcEnabledOnBagSection } = this.props;
    const giftServiceError = sfsError && hasGiftServiceError(sfsError);
    if (isGcEnabledOnBagSection && giftServiceError && !isModalOpen && !this.isErrorShown) {
      this.handleModalOpen();
      this.isErrorShown = true;
    }
  }

  handleMobileSaveAndContinue = () => {
    const {
      giftServicesInputs: { optionId, message, brand },
      savedGiftService: { optionId: savedOptionId, hasGiftWrapping },
      submitSaveAndContinueShipping,
      isGcEnabledOnBagSection,
      sfsError,
      setSFSErrors,
    } = this.props;
    const updatedGiftServicesForm =
      optionId === GIFT_SERVICES_CONSTANTS.GIFT_SERVICES_OPTION_NONE
        ? { hasGiftWrapping: false, optionId: savedOptionId }
        : { hasGiftWrapping: true, optionId, brand, message };
    this.updateGiftServicesForm(updatedGiftServicesForm);
    this.toggleModalVisibility({ isModalOpen: false });
    const giftServiceError = sfsError && hasGiftServiceError(sfsError);
    if (isGcEnabledOnBagSection && giftServiceError) {
      setSFSErrors(null);
    }
    if (
      (!isGcEnabledOnBagSection ||
        hasGiftWrapping ||
        (optionId && !optionId.includes(GIFT_SERVICES_CONSTANTS.GIFT_SERVICES_OPTION_NONE))) &&
      submitSaveAndContinueShipping
    ) {
      submitSaveAndContinueShipping();
    }
    this.isErrorShown = false;
  };

  handleSfsClearGiftService = () => {
    const {
      submitSaveAndContinueShipping,
      savedGiftService: { optionId } = {},
      handleToggle,
    } = this.props;
    this.updateGiftServicesForm({
      hasGiftWrapping: false,
      message: '',
      optionId: optionId || 'none',
      brand: GIFT_SERVICES_CONSTANTS.TCP,
    });
    submitSaveAndContinueShipping();
    this.isErrorShown = false;
    handleToggle(undefined, GIFT_SERVICES_CONSTANTS.TCP, 'None');
  };

  toggleModalVisibility = ({ isModalOpen = false }) => {
    this.setState({ isModalOpen });
  };

  handleModalOpen = () => {
    const { giftServicesInputs, savedGiftService } = this.props;
    const giftOptionsdefault = savedGiftService?.hasGiftWrapping
      ? savedGiftService
      : giftServicesInputs;
    if (giftOptionsdefault) {
      this.updateGiftServicesForm(giftOptionsdefault);
      const { name } = giftOptionsdefault;
      if (name?.toLowerCase().search('deluxe') !== -1) {
        this.setState({ giftType: 'deluxe' });
      } else if (name?.toLowerCase().search('standard') !== -1) {
        this.setState({ giftType: 'standard' });
      } else {
        this.setState({ giftType: '' });
      }
    } else {
      this.updateGiftServicesForm({
        hasGiftWrapping: true,
        message: '',
        optionId: 'none',
        brand: GIFT_SERVICES_CONSTANTS.TCP,
      });
    }
    this.toggleModalVisibility({ isModalOpen: true });
  };

  handleModalCancel = () => {
    const { savedGiftService, handleToggle, setSFSErrors, sfsError, isGcEnabledOnBagSection } =
      this.props;
    const giftServiceError = isGcEnabledOnBagSection && sfsError && hasGiftServiceError(sfsError);

    if (savedGiftService && savedGiftService.hasGiftWrapping) {
      if (giftServiceError) {
        this.handleSfsClearGiftService();
        setSFSErrors(null);
      } else {
        handleToggle(undefined, savedGiftService.brand, savedGiftService.name);
        this.updateGiftServicesForm(savedGiftService);
      }
    } else {
      handleToggle(undefined, GIFT_SERVICES_CONSTANTS.TCP, 'None');
      this.updateGiftServicesForm({
        hasGiftWrapping: false,
        message: '',
        optionId: 'none',
        brand: GIFT_SERVICES_CONSTANTS.TCP,
      });
      if (giftServiceError) {
        setSFSErrors(null);
      }
    }
    this.toggleModalVisibility({ isModalOpen: false });
  };

  updateGiftServicesForm = (payload) => {
    const { hasGiftWrapping = true, message, optionId, brand, giftservice } = payload;
    const { dispatch } = this.props;
    dispatch(change('GiftServices', `hasGiftWrapping`, hasGiftWrapping));
    dispatch(change('GiftServices', `message`, message));
    dispatch(change('GiftServices', `optionId`, optionId));
    dispatch(change('GiftServices', `brand`, brand));
    dispatch(change('GiftServices', `giftservice`, giftservice));
  };

  getImages = () => {
    const { SelectedBrand } = this.props;
    const { GYM, TCP, SNJ, PJP } = GIFT_SERVICES_CONSTANTS;
    const images = { standard: null, deluxe: null };
    if (SelectedBrand === TCP) {
      images.standard = getIconPath('gift_service_standard_tcp');
      images.deluxe = getIconPath('gift_service_deluxe_tcp');
    } else if (SelectedBrand === GYM) {
      images.standard = getIconPath('gift_service_standard_gym');
      images.deluxe = getIconPath('gift_service_deluxe_gym');
    } else if (SelectedBrand === SNJ) {
      images.standard = getIconPath('gift_service_standard_snj');
      images.deluxe = getIconPath('gift_service_deluxe_snj');
    } else if (SelectedBrand === PJP) {
      images.standard = getIconPath('gift_service_standard_pjp');
      images.deluxe = getIconPath('gift_service_deluxe_pjp');
    }
    return images;
  };

  giftServiceChanged = (e, value, name) => {
    const { dispatch, initialValues } = this.props;

    if (name?.toLowerCase().search('deluxe') !== -1) {
      this.setState({ giftType: 'deluxe' });
    } else if (name?.toLowerCase().search('standard') !== -1) {
      this.setState({ giftType: 'standard' });
    } else {
      this.setState({ giftType: '' });
    }
    if (dispatch) {
      if (value.toLowerCase().search('none') !== -1) {
        dispatch(
          change(
            'GiftServices',
            `optionId`,
            `${value}_${
              initialValues?.optionId
                ? initialValues?.optionId
                : GIFT_SERVICES_CONSTANTS.GIFT_SERVICES_NONE_VALUE
            }`
          )
        );
      } else {
        dispatch(change('GiftServices', `optionId`, value));
      }
    }
  };

  giftServiceDefaultChanged = (value) => {
    const { dispatch, SelectedBrand } = this.props;
    if (dispatch) {
      dispatch(change('GiftServices', `optionId`, value));
      dispatch(change('GiftServices', `brand`, SelectedBrand));
    }
  };

  getActiveTitle = (giftOptions, value) => {
    const giftOptionsArray = JSON.parse(giftOptions);
    const options = giftOptionsArray?.giftOptions;
    const selectedOption = options?.find((o) => o?.catEntryId === value?.optionId);
    if (!selectedOption) {
      return {
        catEntryId: renderLabel(
          this.shippingPageLabels?.lbl_gift_service_option_none,
          'lbl_gift_service_option_none'
        ),
      };
    }
    return selectedOption;
  };

  getWrapperTiles = (
    activeValue,
    currencySymbol,
    giftServicesList,
    isMobileView,
    isGcEnabledOnBagSection
    // eslint-disable-next-line sonarjs/cognitive-complexity
  ) => {
    const selectedBrandValue = giftServicesList.find(
      (giftItem) => giftItem.name === activeValue.name
    );
    if (selectedBrandValue && selectedBrandValue?.catEntryId) {
      this.giftServiceDefaultChanged(selectedBrandValue?.catEntryId);
    }
    const giftServices = giftServicesList.map((giftCardOption, index) => {
      const price = giftCardOption.price > 0 ? `${currencySymbol} ${giftCardOption.price}` : 'FREE';
      const { standard, deluxe } = this.getImages();
      let giftWrapperImage = index === 1 ? standard : null;
      if (index === 2) {
        giftWrapperImage = deluxe;
      }
      return (
        <Col
          colSize={{
            small: 6,
            medium: `${window.innerWidth > '945' ? 3 : 6}`,
            large: `${window.innerWidth > '1439' ? 5 : 6}`,
          }}
        >
          <Field
            component={LabeledRadioButton}
            key={giftCardOption.name}
            selectedValue={giftCardOption.name}
            aria-label={giftCardOption.name}
            className={`gift-service-option-card ${
              activeValue?.catEntryId === giftCardOption.catEntryId ||
              activeValue?.name === giftCardOption.name
                ? 'active-gift-card'
                : ''
            }`}
            name="giftservice"
            disabled={false}
            onChange={(e) =>
              this.giftServiceChanged(e, giftCardOption.catEntryId, giftCardOption.name)
            }
            checked={
              activeValue?.catEntryId === giftCardOption.catEntryId ||
              activeValue?.name === giftCardOption.name
            }
          >
            <section className="giftservice-content">
              <section>
                {isGcEnabledOnBagSection ? (
                  <BodyCopy
                    fontFamily="secondary"
                    fontWeight="bold"
                    textAlign="left"
                    fontSize="fs14"
                    color="gray.900"
                    className="giftservice-heading"
                  >
                    {`${giftCardOption.name} - `}
                    <span className="giftservice-price">{price}</span>
                  </BodyCopy>
                ) : (
                  <BodyCopy
                    fontFamily="secondary"
                    fontWeight="bold"
                    textAlign="left"
                    fontSize="fs14"
                    color="gray.900"
                    className="giftservice-heading"
                  >
                    {`${giftCardOption.name} - ${!isMobileView ? price : ''}`}
                  </BodyCopy>
                )}
                {isMobileView && !isGcEnabledOnBagSection && (
                  <BodyCopy
                    fontFamily="secondary"
                    fontWeight="extrabold"
                    textAlign="left"
                    fontSize="fs14"
                    color="gray.900"
                  >
                    {price}
                  </BodyCopy>
                )}
                {/* </section> */}
                <BodyCopy
                  className="giftservice-content-text"
                  fontFamily="secondary"
                  textAlign="left"
                  fontSize="fs12"
                  color="gray.900"
                >
                  {giftCardOption.longDescription}
                </BodyCopy>
              </section>
              {giftWrapperImage && (
                <Image
                  alt=""
                  className="giftservice-content-image"
                  src={giftWrapperImage}
                  data-locator={getLocator(giftWrapperImage)}
                />
              )}
            </section>
          </Field>
        </Col>
      );
    });
    return (
      <>
        {giftServices}
        <Col colSize={{ small: 12, medium: 5, large: 5 }}>
          <Field
            component={LabeledRadioButton}
            key={renderLabel(
              this.shippingPageLabels?.lbl_gift_service_option_none,
              'lbl_gift_service_option_none'
            )}
            selectedValue={renderLabel(
              this.shippingPageLabels?.lbl_gift_service_option_none,
              'lbl_gift_service_option_none'
            )}
            aria-label={renderLabel(
              this.shippingPageLabels?.lbl_gift_service_option_none,
              'lbl_gift_service_option_none'
            )}
            className={`gift-service-option-card ${
              activeValue?.catEntryId.split('_')?.[0] ===
              renderLabel(
                this.shippingPageLabels?.lbl_gift_service_option_none,
                'lbl_gift_service_option_none'
              )
                ? 'active-gift-card'
                : ''
            }`}
            name="giftservice"
            disabled={false}
            onChange={(e) =>
              this.giftServiceChanged(
                e,
                GIFT_SERVICES_CONSTANTS.GIFT_SERVICES_OPTION_NONE,
                renderLabel(
                  this.shippingPageLabels?.lbl_gift_service_option_none,
                  'lbl_gift_service_option_none'
                )
              )
            }
            checked={
              activeValue?.catEntryId ===
              renderLabel(
                this.shippingPageLabels?.lbl_gift_service_option_none,
                'lbl_gift_service_option_none'
              )
            }
          >
            <BodyCopy
              fontFamily="secondary"
              fontWeight="bold"
              textAlign="left"
              fontSize="fs14"
              color="gray.900"
            >
              {renderLabel(
                this.shippingPageLabels?.lbl_gift_service_option_none,
                'lbl_gift_service_option_none'
              )}
            </BodyCopy>
          </Field>
        </Col>
      </>
    );
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  getServicesOptions = (giftWrapOptions) => {
    const { SelectedBrand } = this.props;
    const parsedGiftWrapOptions = JSON.parse(giftWrapOptions);
    const getServicesOptionsMap = parsedGiftWrapOptions.giftOptions;

    return getServicesOptionsMap
      ?.filter(
        (servicesMap) => servicesMap.itemBrand === SelectedBrand || servicesMap.itemBrand === 'ALL'
      )
      ?.sort((a, b) => (a?.price > b?.price ? 1 : -1));
  };

  getMobileViewTitle = (giftServicesList, activeValue) => {
    const { isModalOpen } = this.state;
    const { giftServicesInputs: { hasGiftWrapping } = {} } = this.props;
    let activeTitle = renderLabel(
      this.shippingPageLabels?.lbl_add_gift_services,
      'lbl_add_gift_services'
    );
    const updatedTile =
      giftServicesList && giftServicesList.find((o) => o.catEntryId === activeValue.catEntryId);
    if (updatedTile && !isModalOpen && hasGiftWrapping) {
      activeTitle = updatedTile.name;
    }
    return activeTitle;
  };

  getGcDesc = () => {
    return (
      <BodyCopy
        className="addReceipt giftService-Header"
        fontFamily="secondary"
        fontSize="fs14"
        fontWeight="regular"
        textAlign="left"
        dataLocator={getLocator('addMessage_txt')}
      >
        {renderLabel(
          this.shippingPageLabels?.lbl_gift_service_select_a_brand,
          'lbl_gift_service_select_a_brand'
        )}
      </BodyCopy>
    );
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity, complexity
  render() {
    const {
      className,
      labels,
      giftWrapOptions,
      handleToggle,
      SelectedBrand,
      giftServicesInputs,
      giftDetailRichText,
      giftDetailsGymRichText,
      giftDetailsSnjRichText,
      giftDetailsPjpRichText,
      isSnjPjpGiftServicesDisabled,
      savedGiftService,
      isGcEnabledOnBagSection,
      isMixedOrder,
      sfsError,
      setSFSErrors,
      addSFSItemsToSFL,
      cartOrderItems,
    } = this.props;
    const { hasGiftWrapping: isShippingCheckboxSelected, message: textFieldMessage } =
      giftServicesInputs || {};
    const isMobileView = isClient() && getViewportInfo().isMobile;
    const giftServicesList = this.getServicesOptions(giftWrapOptions, labels);
    const { currencySymbol } = this.props;
    const { detailStatus, message, isModalOpen, giftType } = this.state;
    let noteValue = '';
    if (giftType === 'standard') {
      noteValue = renderLabel(
        this.shippingPageLabels?.lbl_gift_service_note_standard,
        'lbl_gift_service_note_standard'
      );
    } else if (giftType === 'deluxe') {
      noteValue = renderLabel(
        this.shippingPageLabels?.lbl_gift_service_note_delux,
        'lbl_gift_service_note_delux'
      );
    } else {
      noteValue = '';
    }
    const activeValue = this.getActiveTitle(giftWrapOptions, giftServicesInputs);
    const MainContainer = isMobileView || isGcEnabledOnBagSection ? Modal : BodyCopy;
    const activeGiftName = activeValue?.name;
    const maxLength = (max) => (value) => {
      let v;
      const result = value.length > max;
      if (result === false) {
        v = value;
      }
      return v;
    };

    const addGiftServicesTitle = renderLabel(
      this.shippingPageLabels?.lbl_add_gift_services,
      'lbl_add_gift_services'
    );

    const showSnjPjpGiftServices = isSnjPjpGiftServicesDisabled
      ? savedGiftService?.brand === 'SNJ' || savedGiftService?.brand === 'PJP'
      : true;

    const isTcpSelected = SelectedBrand === GIFT_SERVICES_CONSTANTS.TCP;
    const isGymSelected = SelectedBrand === GIFT_SERVICES_CONSTANTS.GYM;
    const isSnjSelected = SelectedBrand === GIFT_SERVICES_CONSTANTS.SNJ;
    const isPjpSelected = SelectedBrand === GIFT_SERVICES_CONSTANTS.PJP;
    return (
      <form className={className} noValidate>
        {isMobileView && !isGcEnabledOnBagSection && (
          <div className="checkbox-header">
            <Field
              customHandleChange
              name="hasGiftWrapping"
              component={InputCheckbox}
              dataLocator={getLocator('gift_service')}
              enableSuccessCheck={false}
              onChange={this.handleModalOpen}
              className="giftServicesField"
              labels={labels}
              spc
            />
            <Row fullBleed className="checkbox-header title g">
              <Image
                className="header-icon elem-pl-SM"
                width="21px"
                height="22px"
                src={getIconPath(GIFT_SERVICES)}
                alt="gift-services"
              />
              <BodyCopy
                component="div"
                className="elem-pl-XS elem-mt-XXXS mobile-title"
                fontFamily="secondary"
                fontWeight="semibold"
                fontSize="fs14"
              >
                {this.getMobileViewTitle(giftServicesList, activeValue)}
              </BodyCopy>
            </Row>
          </div>
        )}
        {isGcEnabledOnBagSection && (
          <GiftServicesHeaderContentNew
            isMobileView={isMobileView}
            handleChange={this.handleModalOpen}
            isModalOpen={isModalOpen}
            savedGiftService={savedGiftService}
            currencySymbol={currencySymbol}
            isMixedOrder={isMixedOrder}
            shippingPageLabels={this.shippingPageLabels}
          />
        )}
        <MainContainer
          isOpen={isModalOpen}
          onRequestClose={this.handleModalCancel}
          overlayClassName="TCPModal__Overlay"
          innerContentClassName={isGcEnabledOnBagSection ? 'gift-services-modal' : ''}
          className={isMobileView || isGcEnabledOnBagSection ? 'TCPModal__Content' : className}
          maxWidth="500px"
          minHeight="90%"
          heightConfig={{ height: '90%' }}
          closeIconDataLocator="details-cross-icon"
          fixedWidth
          contentLabel={renderLabel(
            this.shippingPageLabels?.lbl_giftServices_help,
            'lbl_giftServices_help'
          )}
          inheritedStyles={styles}
          heading={
            isGcEnabledOnBagSection
              ? getLabelWithDefaultValue(this.shippingPageLabels, lblAddGiftServices)
              : ''
          }
          spc
        >
          {!isGcEnabledOnBagSection && (
            <GiftServicesHeaderContent
              isMobileView={isMobileView}
              labels={labels}
              addGiftServicesTitle={addGiftServicesTitle}
              handleChange={this.handleChange}
              isModalOpen={isModalOpen}
              isGcEnabledOnBagSection={isGcEnabledOnBagSection}
            />
          )}
          {getGiftServicesContent({
            isMobileView,
            isShippingCheckboxSelected,
            isGcEnabledOnBagSection,
          }) && (
            <>
              {isGcEnabledOnBagSection && (
                <SfsWarningPrompt
                  sfsError={sfsError}
                  cartOrderItems={cartOrderItems}
                  setSFSErrors={setSFSErrors}
                  toggleModalVisibility={this.toggleModalVisibility}
                  handleSfsClearGiftService={this.handleModalCancel}
                  addSFSItemsToSFL={addSFSItemsToSFL}
                />
              )}
              {isGcEnabledOnBagSection && this.getGcDesc()}
              <Row
                fullBleed
                className={`giftServicesContainer${showSnjPjpGiftServices ? '' : ' gc-full-width'}`}
              >
                {!isGcEnabledOnBagSection && this.getGcDesc()}
                <Col
                  colSize={{ small: 4, medium: 4, large: 6 }}
                  className={`phone-field-wrapper ${
                    isTcpSelected ? 'isBrandTabSelected' : ''
                  } gift-brand-wrapper-tcp`}
                >
                  <Field
                    component={LabeledRadioButton}
                    key={GIFT_SERVICES_CONSTANTS.TCP}
                    selectedValue={GIFT_SERVICES_CONSTANTS.TCP}
                    name="brand"
                    disabled={false}
                    aria-label={BRAND_NAMES.tcp}
                    className="tcp-radio-button"
                    onChange={(e) => handleToggle(e, GIFT_SERVICES_CONSTANTS.TCP, activeGiftName)}
                    checked={isTcpSelected}
                  >
                    <BodyCopy color="gray.900" fontSize="fs14" fontFamily="secondary">
                      <Image
                        alt=""
                        className="brand-image brand-image-tcp"
                        src={getIconPath(`header__brand-tab-tcp`)}
                        data-locator={getLocator('logo_TCP')}
                      />
                    </BodyCopy>
                  </Field>
                </Col>
                <Col
                  colSize={{ small: 4, medium: 4, large: 6 }}
                  className={`phone-field-wrapper ${
                    isGymSelected ? 'isBrandTabSelected' : ''
                  } gift-brand-wrapper-gym`}
                >
                  <Field
                    component={LabeledRadioButton}
                    key={GIFT_SERVICES_CONSTANTS.GYM}
                    selectedValue={GIFT_SERVICES_CONSTANTS.GYM}
                    aria-label={BRAND_NAMES.gym}
                    className="gym-radio-button"
                    name="brand"
                    disabled={false}
                    onChange={(e) => handleToggle(e, GIFT_SERVICES_CONSTANTS.GYM, activeGiftName)}
                    checked={isGymSelected}
                  >
                    <BodyCopy color="gray.900" fontSize="fs14" fontFamily="secondary">
                      <Image
                        alt=""
                        className="brand-image brand-image-gym"
                        src={getIconPath(`header__brand-tab-gym`)}
                        data-locator={getLocator('logo_gymboree')}
                      />
                    </BodyCopy>
                  </Field>
                </Col>
                {showSnjPjpGiftServices && (
                  <Col
                    colSize={{ small: 4, medium: 4, large: 2 }}
                    className={`phone-field-wrapper ${
                      isSnjSelected ? 'isBrandTabSelected' : ''
                    } gift-brand-wrapper-snj`}
                  >
                    <Field
                      component={LabeledRadioButton}
                      key={GIFT_SERVICES_CONSTANTS.SNJ}
                      selectedValue={GIFT_SERVICES_CONSTANTS.SNJ}
                      aria-label={BRAND_NAMES.snj}
                      className="snj-radio-button"
                      name="brand"
                      disabled={false}
                      onChange={(e) => handleToggle(e, GIFT_SERVICES_CONSTANTS.SNJ, activeGiftName)}
                      checked={isSnjSelected}
                    >
                      <BodyCopy
                        color="gray.900"
                        fontSize="fs14"
                        fontFamily="secondary"
                        className="image-container"
                      >
                        <Image
                          alt=""
                          className="brand-image brand-image-snj"
                          src={getIconPath(`header__brand-tab-snj`)}
                          data-locator={getLocator('logo_SNJ')}
                        />
                      </BodyCopy>
                    </Field>
                  </Col>
                )}
                {showSnjPjpGiftServices && (
                  <Col
                    colSize={{ small: 4, medium: 4, large: 6 }}
                    className={`phone-field-wrapper ${
                      isPjpSelected ? 'isBrandTabSelected' : ''
                    } gift-brand-wrapper-pjp`}
                  >
                    <Field
                      component={LabeledRadioButton}
                      key={GIFT_SERVICES_CONSTANTS.PJP}
                      selectedValue={GIFT_SERVICES_CONSTANTS.PJP}
                      aria-label={BRAND_NAMES.pjp}
                      className="pjp-radio-button"
                      name="brand"
                      disabled={false}
                      onChange={(e) => handleToggle(e, GIFT_SERVICES_CONSTANTS.PJP, activeGiftName)}
                      checked={isPjpSelected}
                    >
                      <BodyCopy
                        color="gray.900"
                        fontSize="fs14"
                        fontFamily="secondary"
                        className="pjp-gift-logo"
                      >
                        <Image
                          alt=""
                          className="brand-image brand-image-pjp"
                          src={getIconPath(`header__brand-tab-pjp`)}
                          data-locator={getLocator('logo_pjp')}
                        />
                      </BodyCopy>
                    </Field>
                  </Col>
                )}
              </Row>
              <Row className="edit-form-css gs-radio-btn-wrapper" fullBleed>
                {this.getWrapperTiles(
                  activeValue,
                  currencySymbol,
                  giftServicesList,
                  isMobileView,
                  isGcEnabledOnBagSection
                )}
              </Row>
              {noteValue ? (
                <Row className="giftservice-note" fullBleed>
                  <BodyCopy
                    fontFamily="secondary"
                    textAlign="left"
                    fontSize="fs12"
                    color="gray.600"
                    component="div"
                    dangerouslySetInnerHTML={{ __html: noteValue }}
                  />
                </Row>
              ) : null}
              {getTextFieldHeadingText(labels, maxLength, message, textFieldMessage)}
              {(isMobileView || isGcEnabledOnBagSection) && (
                <Col
                  className={`button-wrapper${
                    isPjpSelected || isSnjSelected ? ' absolute-position' : ''
                  }`}
                  colSize={{ small: 6, medium: 8, large: 12 }}
                >
                  <Button
                    buttonVariation="fixed-width"
                    fill="BLUE"
                    type="button"
                    className={isGcEnabledOnBagSection ? 'gc-save-button' : ''}
                    onClick={this.handleMobileSaveAndContinue}
                    spc
                  >
                    {renderLabel(
                      this.addressLabels?.lbl_addEditAddress_saveAndContinue,
                      'lbl_addEditAddress_saveAndContinue'
                    )}
                  </Button>
                </Col>
              )}
            </>
          )}
          <GiftServicesDetailsModal
            labels={labels}
            openState={detailStatus}
            onRequestClose={() => {
              this.setState({
                detailStatus: false,
              });
            }}
            heading={renderLabel(
              this.shippingPageLabels?.lbl_add_gift_services,
              'lbl_add_gift_services'
            )}
            brand={SelectedBrand}
            dataLocator={getLocator('details_modal')}
            modalRichText={giftDetailRichText}
            giftDetailsGymRichText={giftDetailsGymRichText}
            giftDetailsSnjRichText={giftDetailsSnjRichText}
            giftDetailsPjpRichText={giftDetailsPjpRichText}
          />
        </MainContainer>
      </form>
    );
  }
}

GiftServicesSPC.propTypes = {
  className: PropTypes.string,
  isGiftServicesChecked: PropTypes.bool,
  labels: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func,
  giftWrapOptions: PropTypes.shape({}).isRequired,
  initialValues: PropTypes.shape({}),
  handleToggle: PropTypes.func.isRequired,
  SelectedBrand: PropTypes.string.isRequired,
  handleAnalytics: PropTypes.func.isRequired,
  getGiftServicesContentTcpInfo: PropTypes.shape({}).isRequired,
  getGiftServicesContentGymInfo: PropTypes.shape({}).isRequired,
  giftServicesInputs: PropTypes.shape({}).isRequired,
  deselectCallback: PropTypes.func,
  addressLabels: PropTypes.shape({}).isRequired,
  spc: PropTypes.bool,
  savedGiftService: PropTypes.shape({}).isRequired,
  giftDetailRichText: PropTypes.string,
};

GiftServicesSPC.defaultProps = {
  className: '',
  isGiftServicesChecked: false,
  dispatch: () => {},
  initialValues: {},
  deselectCallback: () => {},
  spc: false,
  giftDetailRichText: null,
};

GiftServicesHeaderContent.propTypes = {
  isMobileView: PropTypes.bool,
  labels: PropTypes.shape({}).isRequired,
  addGiftServicesTitle: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool,
};

GiftServicesHeaderContent.defaultProps = {
  isMobileView: false,
  isModalOpen: false,
};

export { GiftServicesSPC as GiftServicesVanilla };

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: getInitialValues(ownProps),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'GiftServices',
    enableReinitialize: true,

    // a unique identifier for this form
  })(withStyles(GiftServicesSPC, styles))
);
